import imageMapResize from 'image-map-resizer';

document.addEventListener('DOMContentLoaded', () => {
  //////features
  ////search formの表示・非表示・popupの位置調整
  // 純粋関数: ポップアップの位置を計算
  const calculatePopupPosition = (buttonElement, margin = 10) => {
    const { height, top } = buttonElement.getBoundingClientRect();
    return height + top + margin + window.scrollY;
  };

  // DOM操作: ポップアップの位置を調整
  const setPopupPosition = (popup, position) => {
    popup.style.top = `${position}px`;
  };

  // 純粋関数: アクティブなコンテンツのロールを取得
  const getActiveContentRole = (button) => `search-form-popup-${button.dataset.role.split('-')[4]}`;

  // DOM操作: モーダルとコンテンツの表示切り替え
  const toggleModalAndContents = (popup, contents, role) => {
    popup.classList.add('searchForm__categoryPopUp--active');
    contents.forEach((content) => {
      content.classList.toggle('searchForm__categoryContents--active', content.dataset.role === role);
    });
  };

  // DOM操作: ボタンのアクティブ状態の切り替え
  const toggleActiveButton = (buttons, activeButton) => {
    buttons.forEach((btn) => btn.classList.toggle('u-searchFormCategoryButton--active', btn === activeButton));
  };

  const togglePopupVisibility = (popup, isVisible) => {
    if (isVisible) {
      popup.classList.add('searchForm__categoryPopUp--active');
    } else {
      popup.classList.remove('searchForm__categoryPopUp--active');
    }
  };

  const setupButtonEventListeners = (buttons, popup, contents) => {
    let resizeHandler = null;
    let activeButton = null;
  
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const role = getActiveContentRole(button);
        const isActiveButtonClicked = button === activeButton;
  
        if (isActiveButtonClicked) {
          togglePopupVisibility(popup, false);
          toggleActiveButton(buttons, null);
          activeButton = null;
        } else {
          toggleModalAndContents(popup, contents, role);
          setPopupPosition(popup, calculatePopupPosition(button));
          toggleActiveButton(buttons, button);
          activeButton = button;
  
          togglePopupVisibility(popup, true);
        }
  
        if (resizeHandler) {
          window.removeEventListener('resize', resizeHandler);
        }
        resizeHandler = () => {
          // アクティブなボタンが存在する場合のみ位置を計算する
          if (activeButton !== null) {
            setPopupPosition(popup, calculatePopupPosition(activeButton));
          }
        };
        window.addEventListener('resize', resizeHandler);
      });
    });
  
    return () => {
      if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
      }
    };
  };
  

  const removeResizeHandler = setupButtonEventListeners(
    document.querySelectorAll('.searchForm__categoryButton'),
    document.querySelector('.searchForm__categoryPopUp'),
    document.querySelectorAll('[data-role="search-form"] .searchForm__categoryContents')
  );

  // クローズボタンイベント
  const closeButton = document.querySelector('.searchForm__categoryPopUpCloseButton');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      document.querySelector('.searchForm__categoryPopUp').classList.remove('searchForm__categoryPopUp--active');
      document
        .querySelectorAll('[data-role="search-form"] .searchForm__categoryContents')
        .forEach((content) => content.classList.remove('searchForm__categoryContents--active'));
      document
        .querySelectorAll('.searchForm__categoryButton')
        .forEach((button) => button.classList.remove('u-searchFormCategoryButton--active'));
      removeResizeHandler();
    });
  }

  // search_formのエリア
  const toggleButtons = document.querySelectorAll('.searchForm__areaToggleButton');
  const checkboxes = document.querySelectorAll('.searchForm__areaMapCheckbox');

  function updateAreaMapImageClass(areaId) {
    const areaImage = document.getElementById(areaId);
    const parentCheckbox = document.querySelector(
      `.searchForm__areaCheckboxLabel--${areaId} .searchForm__areaMapCheckbox`
    );
    const childCheckboxes = document.querySelectorAll(`.searchForm__childCategoryArea [data-area-id="${areaId}"]`);

    // 親または子のチェックボックスが一つでもチェックされているか確認する
    const isChecked = parentCheckbox.checked || Array.from(childCheckboxes).some((checkbox) => checkbox.checked);

    if (isChecked) {
      areaImage.classList.add('checked');
    } else {
      areaImage.classList.remove('checked');
    }
  }

  const handleCheckboxChange = (checkbox) => {
    const areaId = checkbox.dataset.areaId;
    updateAreaMapImageClass(areaId);
  }

  // チェックボックスの状態を監視する
  checkboxes.forEach((checkbox) => {
    // ロード時にチェックの状態に応じて処理をする
    handleCheckboxChange(checkbox)

    checkbox.addEventListener('change', () => {
      handleCheckboxChange(checkbox)
    });
  });

  // エリアボタンのクリックイベントを処理する
  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const area = button.dataset.area;
      const isActive = button.classList.contains('searchForm__areaToggleButton--active');
      const parentCheckbox = document.querySelector(
        `.searchForm__areaCheckboxLabel--${area} .searchForm__areaMapCheckbox`
      );

      if (isActive) {
        button.classList.remove('searchForm__areaToggleButton--active');
        if (parentCheckbox) {
          parentCheckbox.checked = false;
          parentCheckbox.dispatchEvent(new Event('change')); // ここでchangeイベントを発火
        }
      } else {
        button.classList.add('searchForm__areaToggleButton--active');
        if (parentCheckbox) {
          parentCheckbox.checked = true;
          parentCheckbox.dispatchEvent(new Event('change')); // ここでchangeイベントを発火
        }
      }

      updateAreaMapImageClass(area);
    });
  });

  // areaタグにイベントリスナーを設定
  document.querySelectorAll('area').forEach((area) => {
    area.addEventListener('click', (event) => {
      event.preventDefault(); // デフォルトの動作を阻止
      const areaId = area.getAttribute('data-area-id');
      const toggleButton = document.querySelector(`.searchForm__areaToggleButton--${areaId}`);

      if (toggleButton) {
        toggleButton.click(); // 対応する.toggleButtonをプログラムによりクリックする
      }
    });
  });

  const parentCheckboxes = document.querySelectorAll('.searchForm__areaMapCheckbox--parent');

  // 親カテゴリのチェックボックスの状態に応じてトグルボタンの状態を更新する関数
  const updateToggleButtonState = () => {
    parentCheckboxes.forEach((checkbox) => {
      const areaId = checkbox.dataset.areaId;
      const toggleButton = document.querySelector(`.searchForm__areaToggleButton--${areaId}`);

      if (toggleButton) {
        if (checkbox.checked) {
          toggleButton.classList.add('searchForm__areaToggleButton--active');
        } else {
          toggleButton.classList.remove('searchForm__areaToggleButton--active');
        }
      }
    });
  };

  // 親カテゴリのチェックボックスの状態が変更されたときにトグルボタンの状態を更新する
  parentCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateToggleButtonState);
  });

  // ページ読み込み時にトグルボタンの初期状態を設定
  updateToggleButtonState();


  // 親カテゴリーのチェックボックスをすべて取得
  const parentAreas = document.querySelectorAll('.searchForm__areaMapCheckbox');
  if (parentAreas) {
    // 各親カテゴリーのチェックボックスにイベントリスナーを追加
    parentAreas.forEach((parentArea) => {
      parentArea.addEventListener('change', () => {
        const parentIndex = parentArea.getAttribute('data-parent-index'); // 親カテゴリーのインデックスを取得
        const isChecked = parentArea.checked; // 親カテゴリーのチェック状態を取得
        // 対応する子カテゴリーのチェックボックスを取得し、チェック状態を更新
        const childCheckboxes = document.querySelectorAll(`ul[data-child-for="${parentIndex}"] .childCheckBox`);
        childCheckboxes.forEach((childCheckbox) => {
          childCheckbox.checked = isChecked;
        });
      });
    });
  }

  // 子カテゴリのチェックボックスをすべて取得
  const childCheckboxes = document.querySelectorAll('.childCheckBox');
  if (childCheckboxes) {
    childCheckboxes.forEach((childCheckbox) => {
      childCheckbox.addEventListener('change', () => {
        const parentIndex = childCheckbox.closest('ul').getAttribute('data-child-for'); // 子カテゴリーに対応する親カテゴリーのインデックスを取得
        const allSiblings = document.querySelectorAll(`ul[data-child-for="${parentIndex}"] .childCheckBox`);
        const isCheckedAll = Array.from(allSiblings).every((checkbox) => checkbox.checked); // 全ての子カテゴリーがチェックされているか確認

        // 対応する親カテゴリーのチェックボックスを取得し、全てチェックされていればチェックを入れる
        const parentCheckbox = document.querySelector(`.searchForm__areaMapCheckbox[data-parent-index="${parentIndex}"]`);
        if (isCheckedAll) {
          parentCheckbox.checked = true;
        } else {
          parentCheckbox.checked = false;
        }

        updateToggleButtonState()
      });
    });
  }

  imageMapResize();
});
